import React from "react";
import { FinanceContainer } from "./style";
import { getCustomerFinances } from "api/product";
import Loading from "components/loading";
import EmptyState from "components/emptyState";
import NumberFormat from "components/numberFormat";
import Modal from "components/modal";
const CustomerFinancesPage = () => {
  const [finances, setFinances] = React.useState(null);
  const [modalData, setModalData] = React.useState(null);
  const [policyStatus, setPolicyStatus] = React.useState(false);

  React.useLayoutEffect(() => {
    if (finances === null)
      getCustomerFinances()
        .then((res) => {
          setFinances(res.data.items);
        })
        .catch((err) => {});
  }, [finances]);
  const dateShow = (date) => {
    const event = new Date(date);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return event.toLocaleDateString("fa-IR", options);
  };
  if (finances === null) {
    return <Loading />;
  }
  const linkView = (link) => {
    if (typeof link.url === "string") {
      return <a href={link.url}>{link.title}</a>;
    } else {
      return (
        <span className="modal-link" onClick={() => setModalData(link.url)}>
          {link.title}
        </span>
      );
    }
  };
  return (
    <FinanceContainer>
      {finances.length > 0 ? (
        finances.map((order, index) => (
          <div className="items" key={index}>
            <div className="item">{order.title}</div>
            <div className="item">{NumberFormat({ value: order.amount })}</div>
            {/*<div className="item">مهلت پرداخت: {dateShow(order.expire_at)}</div>*/}
            <div className="item">
              <a target="_blank" href={order?.pdf}>
                دعوت‌نامه
              </a>
            </div>
            <div className="item">{order.link && linkView(order.link)}</div>
          </div>
        ))
      ) : (
        <EmptyState message="دعوت‌نامه‌ی ثبت شده‌ای وجود ندارد" />
      )}
      <Modal
        status={modalData}
        size="small"
        close={() => {
          setModalData(false);
        }}
      >
        <div className="modal-text">پرداخت</div>
        <div className="policy">
          <label>
            <input
              type="checkbox"
              checked={policyStatus}
              onChange={() => setPolicyStatus(!policyStatus)}
            />
            <span
          dangerouslySetInnerHTML={{
            __html: modalData?.text ? modalData?.text : "",
          }}
        />
          </label>
        </div>
        <div className="gatways">
          {modalData?.links &&
            modalData?.links.map((gateway, index) => (
              <a
                className="item"
                href={policyStatus ? gateway.url : void 0}
                key={index}
              >
                <img src={`/getways/${gateway.slug}.png`} alt={gateway.title} />
              </a>
            ))}
        </div>
      </Modal>
    </FinanceContainer>
  );
};
export default CustomerFinancesPage;
